import styled from "styled-components"

export const Container = styled.div`
    width: 100%;
    padding: 15px 100px;

    @media (max-width: 768px){
        display: grid;
        padding: 18px 12px; 
        grid-template-columns: repeat(1, 1fr); 
        gap: 18px;
    }

`;

export const FixWidth = styled.div`
    width: 1080px;
    margin-bottom: 18px;
    @media (max-width: 768px){
        width: 100%; 
        margin-bottom: 0px;
    }
`;

export const List = styled.div`
    display: flex;
    width: 100%;
    align-items: center;
    padding: 16px;
    gap: 113px;
    border-radius: 8px;
    background: #FFF;
    
    .date_div{
        display: flex;
        gap: 113px;
    }

    .auction_name_container {
        width:  auto;
        margin-right: auto;
        display: flex;
        gap: 20px;
        align-items: center;
    }

    .auction_name{
        display: flex;
        flex-direction: column;
    }

    .auction_label{
        color: #333;
        font-size: 14px;
        font-weight: 800;
        word-break: break-word;
    }

    @media (max-width: 768px){
        display: flex;
        flex-direction: column;
        gap: 20px;
        .date_div{
            gap: 12px;
        }
    
        .auction_name{
            flex-direction: column;
            gap: 12px;
        }


    }

`;

export const ListTitle = styled.span`
    color: #333;
    font-size: 18px;
    font-weight: 700;
`;

export const SmallText = styled.p`
    color: var(--text-secondary-text, #666);
    font-size: 14px;
    font-weight: 400;
`;

export const DetailContainer = styled.div`
    display: flex;
    width: 135px; 
    max-width: 135px; 
    flex-direction:${prop => prop.flexDirection ? prop.flexDirection: 'row'};
    gap: 8px;
    ${prop => prop.alignItems ? `align-items: ${prop.alignItems};` : ''}
`;

export const TextContainer = styled.div`
    max-width: 115px;
`;

export const Label = styled.label`
    color: #666;
    font-size: 12px;
    font-weight: 400;

`;

export const Text = styled.p`
    color: #333;
    font-size: 14px;
    font-weight: 700;
`;

export const ButtonContainer = styled.div`
    display: flex;
    align-items: center;
    margin-left: auto; 

    @media (max-width: 768px){
        margin-left: 0px;
        justify-content: center; 
    }

`;

export const Button = styled.button`
    color: #F37021;
    font-size: 14px;
    font-weight: 700;
    background: none;
`;